"use strict";
var dragulaExpt = require("dragula");
exports.dragula = dragulaExpt.default || dragulaExpt;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-dragula/components/dragula.class.js
// module id = 333
// module chunks = 3